import React, { createContext, useEffect, useState } from 'react';
import {useDispatch} from "react-redux";
import {Navigate, useNavigate, useLocation} from "react-router-dom";
import jwt_decode from "jwt-decode";
import {getLoginScreenStatus, setLoginScreenStatus} from "../helpers/index.js";
import TopNav from "../components/routing/topNav/index.js";
import PageTracker from "../components/pageTracker/index.js";
import FavIconLoader from "../components/favIconLoader/index.js";
import {externalPathToFilter} from "./externalPathToFilter.js";
import {AUTH_ERROR} from "../actions/types";
import {clearProfilePhotoCache} from "../hooks/useProfilePhoto.js";
import {useInterval} from "react-use";

export const AppContext = React.createContext(null);

const AppContextProvider = (props) => {

	const userStr = sessionStorage.getItem('user') || localStorage.getItem('user');
	let user = JSON.parse(userStr && userStr !== 'undefined' && userStr !== 'null' ? userStr : '{}');

	if (isEmptyObject(user))
		user = null;

	let token = sessionStorage.getItem('token') || localStorage.getItem('token');
	const [jwt, setJwt] = useState(sessionStorage.getItem('token') || localStorage.getItem('token'));
	const [currentUser, setCurrentUser] = useState(user);
	const [timerRef, setTimerRef]  = useState(null);
	const [logoutNotificationConfirmed, setLogoutNotificationConfirmed] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [currentLocation, setCurrentLocation] = useState(location.pathname);

	function isEmptyObject(obj) {
		return obj !== null && typeof obj === 'object' && Object.keys(obj).length === 0;
	}

	const logout = (useTimeoutError) => (navigate) => async (dispatch) => {
		await dispatch({
			type: 'RESET'
		});
		sessionStorage.clear();
		localStorage.clear();
		clearProfilePhotoCache();
		if (useTimeoutError) {
			await dispatch({
				type: AUTH_ERROR,
				payload: 'Your user session has expired.  Please login to continue.',
			});
		}
		navigate('/login');
	}

	const checkTokenExpired = async () => {
		let tokenExpired = token ? (jwt_decode(token).exp * 1000) < Date.now() : false;
		const checkUserStr = sessionStorage.getItem('user') || localStorage.getItem('user');
		JSON.parse(checkUserStr && checkUserStr !== 'undefined' && checkUserStr !== 'null' ? checkUserStr : '{}')

		if (isEmptyObject(user))
			user = null;

		token = sessionStorage.getItem('token') || localStorage.getItem('token');
		const logoutFunc = await logout(true)(navigate);

		if (user)

		if (!user || !token)
			return;

		let currentLocation = location.pathname.split('/')[1];
		if (!externalPathToFilter.includes(currentLocation)) {
			if ((!token || tokenExpired) && !getLoginScreenStatus()) {
				await dispatch(logoutFunc);
			}
		}
	}

	useEffect(async () => {
		const logoutFunc = logout(true)(navigate);

		if (logoutNotificationConfirmed) {
			dispatch(logoutFunc);
		}
	}, [logoutNotificationConfirmed])

	useEffect(async () => {
		setCurrentLocation(location.pathname);

		await checkTokenExpired();
	}, [location]);

	useInterval(async () => {
		setCurrentLocation(location.pathname);
		await checkTokenExpired();
	}, 60000);

	return (
		<AppContext.Provider value={{jwt, setJwt, currentUser, setCurrentUser, logout, setCurrentLocation, currentLocation}}>
			{props.children}
		</AppContext.Provider>
	);
}

export default AppContextProvider;
